export const formName = 'COMPDATA';
